import { createContext, useState, useContext, useEffect } from "react";
import { deleteImageFromServer, deleteProductById, getAllProducts, getProductBatch, getProductById, processOrder, updateProductData, uploadImageToServer, uploadNewProduct } from "./product.services";
import { loadCartItems, getWishListItems } from "../../_helpers/cart.methods";



export const ProductContext = createContext();

export const ProductContextProvider = ({ children }) => {

    const [loading, setLoading] = useState(false);
    const [cart, setCart] = useState([]);
    const [wishList, setWishList] = useState([]);
    const [allProducts, setAllProducts] = useState([]);
    const [someProducts, setSomeProducts] = useState([]);
    const [pageNum, setPageNum] = useState(1);

    const handleNextPage = () => {
        if (someProducts?.length < 20) {
            return;
        }
        setPageNum((num) => num + 1);
    }

    const handlePrevPage = () => {
        if (pageNum === 1) return;
        setPageNum((num) => num - 1);
    }

    const addNewProductImage = async (data) => {
        try {
            setLoading(true);
            const response = await uploadImageToServer(data);
            const imageUrl = await response.json();
            console.log(imageUrl);
            setLoading(false);
            return imageUrl;
        } catch (error) {
            console.log({ error });
        } finally {
            setLoading(false);
        }
    }

    const removeProductImage = async (uri) => {
        try {
            setLoading(true);
            const response = await deleteImageFromServer(uri);
            const resp = await response.json();
            setLoading(false);
            return resp;
        } catch (error) {
            console.log({ error });
        }
    }

    const addNewProduct = async (data, token) => {
        try {
            setLoading(true);
            const response = await uploadNewProduct(data, token);
            const resp = await response.json();
            setLoading(false);
            console.log(resp);
            return resp
        } catch (error) {
            console.log({ error });
        }
    }



    //get all products
    const loadAllProducts = async () => {
        try {
            const response = await getAllProducts();
            const resp = await response.json();
            setAllProducts(resp);
            return resp;
        } catch (error) {
            console.log({ error });
        }
    }

    /**
     * 
     * @param {object} itemData product data 
     * @param {number} qty quantity 
     */
    const addToCart = (itemData, qty) => {
        //read from localstorage
        const data = localStorage.getItem('cart');

        //no cart data e.g. in first use case
        if (!data) {
            //append a quantity property to cart object
            let newData = JSON.stringify([{ ...itemData, quantity: qty }]);
            console.log({ clicked: itemData })
            localStorage.setItem('cart', newData);
            setCart(newData);
            window.location.reload();
        } else {
            const listArray = JSON.parse(data);
            console.log({ listArray });
            //check if item is in cart and remove it
            if (listArray.some((item) => item._id === itemData?._id)) {
                const newArray = listArray.filter((val) => val._id !== itemData?._id);
                localStorage.setItem('cart', JSON.stringify(newArray));
                setCart(newArray);
            } else {
                //add item to cart
                const newArray = [...listArray, { ...itemData, quantity: qty }];
                localStorage.setItem('cart', JSON.stringify(newArray));
                setCart(newArray);
            }
        }
    }


    const addTowishList = (itemData) => {
        //read from localstorage
        const data = localStorage.getItem('wishlist');

        //no wishlist data e.g. in first use case
        if (!data) {
            let newData = JSON.stringify([itemData]);
            localStorage.setItem('wishlist', newData);
            setWishList([itemData]);
        } else {
            const listArray = JSON.parse(data);
            //check if item is in wishlist and remove it
            if (listArray.some((elem) => elem._id === itemData?._id)) {
                const newArray = listArray.filter((val) => val._id !== itemData?._id);
                localStorage.setItem('wishlist', JSON.stringify(newArray));
                setWishList(newArray);
            } else {
                //add item to wish list
                const newArray = [...listArray, itemData];
                setWishList(newArray);
                localStorage.setItem('wishlist', JSON.stringify(newArray));
            }
        }

    }

    const updateCartData = (id, quantity) => {
        const updatedCart = cart.map((item) => {
            return item?._id === id ? { ...item, quantity } : item
        });
        setCart(updatedCart);
        localStorage.setItem('cart', JSON.stringify(updatedCart));
    }

    const upDateProduct = async (data, id, token) => {
        try {
            setLoading(true);
            const response = await updateProductData(data, id, token);
            const resp = await response.json();
            setLoading(false);
            return resp;
        } catch (error) {
            console.log({ error });
        } finally {
            setLoading(false);
        }
    }

    const getProduct = async (id) => {
        try {
            setLoading(true);
            const response = await getProductById(id);
            const resp = await response.json();
            return resp;
        } catch (error) {
            return { error }
        } finally {
            setLoading(false);
        }
    }

    const deleteProduct = async (id, images, token) => {
        try {
            setLoading(true);
            const delErrors = [];
            images.forEach(async (image) => {
                const delResponse = await removeProductImage(image);
                if (delResponse?.error) {
                    delErrors.push(delResponse);
                };
            })
            const response = await deleteProductById(id, token);
            const resp = await response.json();
            return resp;
        } catch (error) {
            console.log({ error });
        } finally {
            setLoading(false);
        }
    }

    const orderProducts = async (orderData) => {
        try {
            setLoading(true);
            const response = await processOrder(orderData);
            const res = await response.json();
            return res;
        } catch (error) {
            console.log({ error });
        } finally {
            setLoading(false);
        }
    }


    useEffect(() => {
        const items = loadCartItems();
        items ? setCart(items) : setCart([]);
        const wishListItems = getWishListItems();
        wishListItems ?
            setWishList(wishListItems) : setWishList([]);
        (async () => {
            //get all products
            const loadAllProducts = async () => {
                try {
                    const response = await getAllProducts();
                    const resp = await response.json();
                    setAllProducts(resp);
                    return resp;
                } catch (error) {
                    console.log({ error });
                }
            }

            await loadAllProducts();
        })();
    }, [])


    useEffect(() => {

        const getProductsByBatch = async (query) => {
            try {
                setLoading(true);
                const response = getProductBatch(query);
                const resp = (await response).json();
                return resp;
            } catch (error) {
                return ({ error });
            } finally {
                setLoading(false);
            }
        }
        (async () => {
            const resp = await getProductsByBatch(`?page=${pageNum}`);
            const someData = resp?.data;
            console.log([someData])
            setSomeProducts(someData);
        })();

    }, [pageNum])

    return (
        <ProductContext.Provider
            value={{
                addNewProductImage,
                removeProductImage,
                addNewProduct,
                addToCart,
                updateCartData,
                loadAllProducts,
                addTowishList,
                upDateProduct,
                getProduct,
                deleteProduct,
                orderProducts,
                handlePrevPage,
                handleNextPage,
                pageNum,
                cart,
                loading,
                wishList,
                allProducts,
                someProducts
            }}
        >
            {children}
        </ProductContext.Provider>
    )
}

export const useProduct = () => useContext(ProductContext);